import './profile.css'
import {useAuthValue} from './AuthContext'
import { signOut } from 'firebase/auth' 
import { auth, db } from './firebase'
import {useState, useEffect} from 'react'
 
import {
 // collection,
 // getDocs,
  doc,
  getDoc,
 // addDoc,
  //updateDoc,
  //deleteDoc,
  //doc,
 // query,
 // where
} from "firebase/firestore";
import { useNavigate, useLocation } from 'react-router-dom'
import logoImg1 from './assets/logoG.png';

function Profile() {
  const {currentUser} = useAuthValue()
  const navigate = useNavigate()
  const [time, setTime] = useState(60)
  const location = useLocation()
  const {timeActive, setTimeActive} = useAuthValue()
  const [datauser, setDatauser] = useState([]) 
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    const interval = setInterval(() => {
      currentUser?.reload()
      .then(() => {
        if(currentUser?.emailVerified){
          clearInterval(interval)
          navigate('/')
        }
      })
      .catch((err) => {
        alert(err.message)
      })
    }, 1000)
  }, [navigate, currentUser])

  useEffect(() => {
    getUserdata();
    
    let interval = null
    if(timeActive && time !== 0 ){
      interval = setInterval(() => {
        setTime((time) => time - 1)
      }, 1000)
    }else if(time === 0){
      setTimeActive(false)
      setTime(60)
      clearInterval(interval)
    }
    return () => clearInterval(interval);
  }, [timeActive, time, setTimeActive,loading])

  const docRef = doc(db, "usuarios", currentUser.uid);
    
  const getUserdata = async () => {
       const docSnap = await getDoc(docRef);
       if (docSnap.exists()) {
        //console.log("Document data:", docSnap.data());
        setDatauser(docSnap.data())
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
        setLoading(false);
      }
      if (loading) {
        setLoading(false);
      }
      
  }  
   

  const handleLogout = () => {               
    signOut(auth).then(() => {
    // Sign-out successful.
        navigate("/login");
        console.log("Signed out successfully")
        //sendSMS()
    }).catch((error) => {
    // An error happened.
    });
  } 

  const handleConsultafone = () => {               
   
        navigate("/queryFone",{state:{iduserlog:currentUser.uid, nomeUser: datauser.nomeUser, emailUser: currentUser.email, grupoparc: datauser.grupoparceiro, empresaVinc: datauser.vinculoEmpresa}});
    //    console.log("Signed out successfully")
        //sendSMS()
    }
   


  return (
      <div className='center'>
        <div className='profile'>
          <img src={logoImg1} width="150" height="150"/>
          <h1>Detalhes da sua conta</h1>
           <p><strong>Email: </strong>{currentUser?.email}</p>
             <p>
            <strong>Email verificado: </strong>
            {`${currentUser?.emailVerified}`}
          </p> { /*
        <span onClick={() => signOut(auth)}>Sign Out</span> */ }
        <p><b><u>Confira abaixo seus dados:</u></b></p>
        <p><strong>Nome: </strong>{datauser?.nomeUser}</p>
        <p><strong>Fone: </strong>{datauser?.foneUser}</p>
        <p><strong>Grupo: </strong>{datauser?.grupoparceiro}</p>
        <p><strong>Documento: </strong>{datauser?.documUser}</p>
         
          {
            datauser?.prestserv == true &&
                      
            <button style={{ backgroundColor:"darkblue", color:"white"}} onClick={() => handleConsultafone()}>Registrar Cashback</button> 
            
          }
        <p>   <button  onClick={() => handleLogout()}>Logoff</button> </p>
        </div>
      </div>
  )
}

export default Profile
